import { apiGet, apiPost, apiDelete, apiPut, API_URI } from 'api';

const board = {
  /*get: async (id: number) => {
    const data = await apiGet(`${API_URI}/api/board/${id}`);
    return data;
  },
  getAll: async (clientId: number) => {
    const data = await apiGet(`${API_URI}/api/board?clientId=${clientId}`);
    return data;
  },
  add: async (clientId: number, name: string) => {
    const data = await apiPost(`${API_URI}/api/board?clientId=${clientId}&description=${name}`);
    return data;
  },
  delete: async (boardId: number) => {
    const data = await apiDelete(`${API_URI}/api/board/${boardId}`);
    return data;
  },
  update: async (boardId: number, name: string, background: string) => {
    const data = apiPut(`${API_URI}/api/board/${boardId}?description=${name}&background=${background}`);
    return data;
  },*/
  background: async (boardId: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const data = await fetch(`${API_URI}/api/board/${boardId}/background`, {
      method: "PUT",
      body: formData,
      headers: {
        "Authorization": `Bearer ${localStorage.AccessToken}`
      }
    });
    return data;
  }/*,
  member: {
    getAll: async (boardId: number) => {
      const data = await apiGet(`${API_URI}/api/boardmember/${boardId}`);
      return data;
    },
    add: async (boardId: number, contactId: number, roleId: number) => {
      const data = await apiPost(`${API_URI}/api/boardmember?boardId=${boardId}&contactId=${contactId}&roleId=${roleId}`);
      return data;
    },
    delete: async (id: number) => {
      const data = await apiDelete(`${API_URI}/api/boardmember/${id}`);
      return data;
    },
    update: async (id: number, roleId: number) => {
      const data = await apiPut(`${API_URI}/api/boardmember/${id}?roleId=${roleId}`);
      return data;
    }
  }*/
};

export default board;